(() => {
  const ready = new WeakSet();
  function initialise(scope = document) {
    scope.querySelectorAll('[data-paginated-section]').forEach(section => {
      if (ready.has(section)) return;
      ready.add(section);
      const status = section.querySelector('[data-page-status]');
      if (!status) return;
      const message = status.querySelector('[data-page-message]');
      const recovery = status.querySelector('[data-page-recovery]');
      const snapshots = new Map();
      let rendered = new URL(location.href), controller, sequence = 0, failed;
      const initialRecipe = history.state?.sinroomBrowse;
      const clean = value => {
        const url = new URL(value, location.origin);
        url.searchParams.delete('section_id');url.searchParams.delete('sections');
        return url;
      };
      const key = value => { const url = clean(value);url.hash='';return url.href; };
      const results = () => section.querySelector('[data-page-results]');
      const pageParam = () => section.querySelector('[data-pagination]')?.dataset.pageParam || 'page';
      const union = () => !!section.querySelector('[data-native-pagination]')?.hidden;
      const fill = (copy, values) => Object.entries(values).reduce((text,[name,value]) => text.replaceAll('__'+name+'__',String(value)),copy || '');
      const grid = node => node.querySelector('[data-catalog-grid]');
      const enhance = () => {
        const current = results();
        if (current && !current.dataset.firstPage) current.dataset.firstPage=current.dataset.page;
        section.querySelectorAll('[data-page-jump]').forEach(form => { form.hidden=false; });
        section.querySelectorAll('[data-page-link],[data-page-load-more]').forEach(link => { link.href=clean(link.href).href; });
        const pager=section.querySelector('[data-page-hybrid]');
        if (!pager || union()) return;
        pager.querySelector('[data-page-append-controls]').hidden=false;
        const options=pager.querySelector('[data-page-options]');
        if (options && !options.dataset.enhanced) { options.open=false;options.dataset.enhanced='true'; }
        const count=grid(current)?.querySelectorAll('[data-result-card]').length || 0;
        const total=Number(pager.dataset.items);
        pager.querySelector('[data-page-count]').textContent=fill(pager.dataset.countCopy,{count,total});
        pager.querySelector('.browse-pagination-progress > span').style.width=(total?Math.min(100,count/total*100):0)+'%';
      };
      const recipe = (scroll=scrollY) => ({key:key(rendered),first:Number(results()?.dataset.firstPage || results()?.dataset.page),last:Number(results()?.dataset.page),scroll});
      const cache = () => {
        if (!results() || union()) return;
        snapshots.delete(key(rendered));
        snapshots.set(key(rendered),{html:results().outerHTML,recipe:recipe()});
        while (snapshots.size>4) snapshots.delete(snapshots.keys().next().value);
      };
      const remember = () => {
        if (!results() || union()) return;
        cache();history.replaceState({...history.state,sinroomBrowse:recipe()},'',rendered.href);
      };
      const metadata = node => {
        const source=node.querySelector('[data-page-meta]');
        if (!source) throw new Error('metadata_missing');
        const meta=JSON.parse(source.textContent);
        if (typeof meta.title!=='string' || typeof meta.canonical!=='string') throw new Error('metadata_invalid');
        return meta;
      };
      const applyMetadata = meta => {
        document.title=meta.title;
        const canonical=document.querySelector('link[rel="canonical"]');
        if (canonical) canonical.href=meta.canonical;
        document.querySelector('meta[property="og:url"]')?.setAttribute('content',meta.canonical);
        document.querySelector('meta[property="og:title"]')?.setAttribute('content',meta.title);
        document.querySelector('meta[name="twitter:title"]')?.setAttribute('content',meta.title);
      };
      const restoreScroll = top => {
        const root=document.documentElement, previous=root.style.scrollBehavior;
        root.style.scrollBehavior='auto';window.scrollTo({top,behavior:'auto'});root.style.scrollBehavior=previous;
      };
      const scrollToResults = node => {
        node.focus({preventScroll:true});
        const top=Math.max(0,node.getBoundingClientRect().top+scrollY-24);
        window.scrollTo({top,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      };
      const fetchPage = async (url,signal,token) => {
        const source=new URL(url);source.searchParams.set('section_id',section.dataset.sectionId);source.hash='';
        const response=await fetch(source.href,{credentials:'same-origin',signal,headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('page_unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const fresh=doc.querySelector('[data-page-results]');
        const expected=Number(url.searchParams.get(pageParam()) || 1);
        if (!fresh || Number(fresh.dataset.page)!==expected || token!==sequence) throw new Error('page_invalid');
        fresh.dataset.firstPage=fresh.dataset.page;metadata(fresh);return fresh;
      };
      const extend = (current,fresh) => {
        const target=grid(current), source=grid(fresh);
        const oldPager=current.querySelector('[data-native-pagination]'), nextPager=fresh.querySelector('[data-native-pagination]');
        if (!target || !source || !oldPager || !nextPager || !nextPager.querySelector('[data-page-hybrid]')) throw new Error('append_invalid');
        if (Number(fresh.dataset.page)!==Number(current.dataset.page)+1) throw new Error('append_out_of_order');
        const seen=new Set([...target.querySelectorAll('[data-result-card]')].map(card=>card.dataset.productId));
        const additions=[...source.querySelectorAll('[data-result-card]')].filter(card=>{
          if (!card.dataset.productId || seen.has(card.dataset.productId)) return false;
          seen.add(card.dataset.productId);return true;
        });
        target.append(...additions);oldPager.replaceWith(nextPager);
        current.dataset.page=fresh.dataset.page;current.dataset.pages=fresh.dataset.pages;return additions;
      };
      const validRecipe = (value,url) => value && value.key===key(url) && Number.isInteger(value.first) && Number.isInteger(value.last) && value.first>=1 && value.last>=value.first && value.last<=Number(results()?.dataset.pages || 0) && value.first===Number(url.searchParams.get(pageParam()) || 1);
      const change = async (target,{push=true,append=false,restore=null}={}) => {
        const url=clean(target);
        if (url.origin!==location.origin || union()) return;
        if (append && section.dataset.pageLoading) return;
        if (push || append) remember();else cache();
        const token=++sequence;
        controller?.abort();controller=new AbortController();
        const previous=results();if (!previous) return;
        const pager=previous.querySelector('[data-pagination]');
        section.dataset.pageLoading='true';section.dataset.pageAppending=String(append);
        previous.setAttribute('aria-busy','true');pager?.setAttribute('aria-busy','true');
        const load=pager?.querySelector('[data-page-load-more]');
        if (load) { load.setAttribute('aria-disabled','true');load.querySelector('[data-load-more-label]').textContent=pager.dataset.appendLoading; }
        status.dataset.append=String(append);status.hidden=false;recovery.hidden=true;
        message.textContent=append?pager.dataset.appendLoading:status.dataset.loading;
        pager?.querySelectorAll('[data-page-append-note],[data-page-append-fallback]').forEach(node=>{node.hidden=true;});
        try {
          let fresh, additions=[];
          const cached=!push && !append && restore && snapshots.get(key(url));
          if (cached && cached.recipe.first===restore.first && cached.recipe.last===restore.last) {
            fresh=new DOMParser().parseFromString(cached.html,'text/html').querySelector('[data-page-results]');
          } else {
            fresh=await fetchPage(url,controller.signal,token);
            if (restore && validRecipe(restore,url)) {
              if (restore.last>Number(fresh.dataset.pages)) throw new Error('range_changed');
              for (let page=restore.first+1;page<=restore.last;page++) {
                const next=new URL(url);next.searchParams.set(pageParam(),String(page));
                extend(fresh,await fetchPage(next,controller.signal,token));
              }
            }
          }
          if (token!==sequence) return;
          const meta=metadata(fresh);
          if (append) {
            additions=extend(previous,fresh);enhance();
            const nextPager=previous.querySelector('[data-page-hybrid]');
            const count=grid(previous).querySelectorAll('[data-result-card]').length;
            message.textContent=fill(nextPager.dataset.appendedCopy,{added:additions.length,count,total:nextPager.dataset.items});
            const focus=additions[0]?.querySelector('a[href]') || nextPager.querySelector('[data-page-load-more],[data-page-options] > summary');
            focus?.focus({preventScroll:true});
            if (!matchMedia('(prefers-reduced-motion: reduce)').matches) additions.slice(0,8).forEach((card,index)=>card.animate?.([{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:220,delay:Math.min(index*20,100),easing:'ease-out'}));
          } else {
            previous.replaceWith(fresh);enhance();applyMetadata(meta);rendered=new URL(url);
            if (push) history.pushState({...history.state,sinroomPage:true,sinroomBrowse:recipe(0)},'',url.href);
            message.textContent=status.dataset.loaded.replace('__current__',fresh.dataset.page).replace('__total__',fresh.dataset.pages);
            if (restore) requestAnimationFrame(()=>{restoreScroll(Number.isFinite(restore.scroll)?Math.max(0,restore.scroll):0);remember();});
            else scrollToResults(fresh);
          }
          failed=null;if (!restore || append) remember();
        } catch (error) {
          if (error.name==='AbortError' || token!==sequence) return;
          failed={url,append,restore};
          if (append) {
            message.textContent=pager.dataset.appendError;
            const note=pager.querySelector('[data-page-append-note]');note.textContent=pager.dataset.appendError;note.hidden=false;note.focus({preventScroll:true});
            const fallback=pager.querySelector('[data-page-append-fallback]');fallback.href=url.href;fallback.hidden=false;
            if (load) load.querySelector('[data-load-more-label]').textContent=status.querySelector('[data-page-retry]').textContent;
          } else {
            history.replaceState({...history.state,sinroomBrowse:recipe()},'',rendered.href);
            message.textContent=status.dataset.error;recovery.hidden=false;status.querySelector('[data-page-fallback]').href=url.href;
            status.focus({preventScroll:true});status.scrollIntoView({block:'nearest',behavior:'auto'});
          }
        } finally {
          if (token===sequence) {
            delete section.dataset.pageLoading;delete section.dataset.pageAppending;
            results()?.removeAttribute('aria-busy');section.querySelector('[data-pagination]')?.removeAttribute('aria-busy');
            section.querySelector('[data-page-load-more]')?.removeAttribute('aria-disabled');
          }
        }
      };
      section.addEventListener('click',event=>{
        const retry=event.target.closest('[data-page-retry]');
        if (retry && failed) { change(failed.url,{push:!failed.append,append:failed.append,restore:failed.restore});return; }
        const link=event.target.closest('[data-page-link],[data-page-load-more]');
        if (!link) { if (event.target.closest('a[href]')) remember();return; }
        if (union() || event.defaultPrevented || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target==='_blank') return;
        event.preventDefault();change(link.href,{append:link.hasAttribute('data-page-load-more')});
      });
      section.addEventListener('submit',event=>{
        const form=event.target.closest('[data-page-jump]');if (!form || union()) return;
        event.preventDefault();if (!form.reportValidity()) return;
        const url=clean(location.href);url.searchParams.set(form.closest('[data-pagination]').dataset.pageParam,form.querySelector('input').value);
        url.hash=results().id;change(url);
      });
      window.addEventListener('popstate',event=>{
        if (!section.isConnected || union()) return;
        const target=clean(location.href);if (key(target)===key(rendered)) return;
        const context=value=>{const url=clean(value);url.searchParams.delete(pageParam());url.hash='';return url.href;};
        if (context(target)!==context(rendered)) { location.reload();return; }
        change(target,{push:false,restore:validRecipe(event.state?.sinroomBrowse,target)?event.state.sinroomBrowse:null});
      });
      window.addEventListener('pagehide',remember);
      enhance();
      if (!union() && validRecipe(initialRecipe,rendered) && initialRecipe.last>Number(results()?.dataset.page)) change(rendered,{push:false,restore:initialRecipe});
      else remember();
    });
  }
  initialise();
  document.addEventListener('shopify:section:load',event=>initialise(event.target));
})();
